/**
 * Display labels for the Exigo order custom-field slots (`other11`..`other20`).
 *
 * These are Exigo *config* names, authoritative source `dbo.OrderFieldNames`
 * (mirrored to `exigo_mirror.order_field_names`, which migration-sync writes and
 * nothing on any read path queries). Following the same convention as
 * `apps/admin-api/src/routes/search-fields.ts`, the map is consulted at
 * development time and baked in here rather than read at runtime: the slot
 * meanings are business conventions that effectively never change, and the
 * order detail page must keep working after mirror retirement
 * (`.claude/rules/sync/mirror-retirement.md`).
 *
 * Labels are kept in step with the operator-facing labels in `search-fields.ts`
 * so search and order detail name the same slot identically — they previously
 * disagreed on `other14` ("isHealthStart" here vs "HSF Order" there vs
 * `HSFOrder` in Exigo). Exigo's spelling wins.
 *
 * `other13` is deliberately absent: it has no name in Exigo (empty string in
 * `OrderFieldNames`) and no agreed business meaning — pending #859.
 */
export const ORDER_FIELD_LABELS: Record<string, string> = {
  other11: 'Total Number of Installments',
  other12: 'Installment Number',
  other14: 'HSF Order',
  other15: 'Shipment Number',
  other16: 'Shopify Order ID',
  other17: 'Legacy Order ID',
  other18: 'Converted Installments',
  other19: 'Shopify Order Number',
  other20: 'Shop Name',
};

/** Label for a slot, falling back to the raw slot name when unnamed (other13). */
export function orderFieldLabel(slot: string): string {
  return ORDER_FIELD_LABELS[slot] ?? slot;
}
